module.exports = __webpack_public_path__ + "img/signs1.39f3a4e9.jpg";